import React from "react";
import { Grid, Code, Text } from "@chakra-ui/react";

const JobProfileList = ({ job_profile }) => {
  return (
    <>
      <Text as="span" fontWeight="bold">job profile:</Text>{" "}
      {
        job_profile.split(',').map((jp, index) => (
          <Text as="span" key={index}>
            {jp.trim()}{index !== job_profile.split(',').length - 1 ? ', ' : ''}
          </Text>
        ))
      }
    </>
  );
};


const BatchOperationDetails = ({ timeStamp }) => {
  return (<>
    <Grid templateColumns="repeat(1, 1fr)" mb={10}>
      <Code colorScheme="">
        <Text as="span" fontWeight="bold">run id:</Text>{" "}
        <Text as="span">{timeStamp?.run_id}</Text>
      </Code>
      <Code colorScheme="">
        <Text as="span" fontWeight="bold">career stage:</Text>{" "}
        <Text as="span">{timeStamp?.career_stage}</Text>
      </Code>
      <Code colorScheme="">
        <Text as="span" fontWeight="bold">pool name:</Text>{" "}
        <Text as="span">{timeStamp?.pool_name}</Text>
      </Code>
      <Code colorScheme="" children={<JobProfileList job_profile={timeStamp?.job_profile} />} />
      <Code colorScheme="">
        <Text as="span" fontWeight="bold">pool created by:</Text>{" "}
        <Text as="span">{timeStamp?.author_email}</Text>
      </Code>
      <Code colorScheme="">
        <Text as="span" fontWeight="bold">batch operation initiated by:</Text>{" "}
        <Text as="span">{timeStamp?.starter_email}</Text>
      </Code>
    </Grid>
  </>
  );
};

export default BatchOperationDetails;
